import { PartnersCodes } from 'constants/partners';

export const PARTNERS_LOGO_CDN_BASE = 'https://cdn.checkmate.tech/checkmate-files/assets/partners/';

const partnerLogo = filename => `${PARTNERS_LOGO_CDN_BASE}${filename}`;

export const PartnersConfig = [
  {
    name: 'account_api',
    logo: 'https://cdn.checkmate.tech/checkmate-files/assets/checkmate_logo.svg',
    title: 'Account API',
    description: 'Learn more about our Account API integration',
  },
  {
    name: 'avature',
    logo: partnerLogo('avature.svg'),
    title: 'Avature',
    description: 'Learn more about our Avature integration',
    documentationUrl: `${process.env.REACT_APP_CHECKMATE_DOC360_URL}/docs/setting-up-the-avature-integration`,
    infoOnly: true,
  },
  {
    name: 'bullhorn',
    logo: partnerLogo('bullhorn.svg'),
    title: 'Bullhorn',
    description: 'Learn more about our Bullhorn integration',
    documentationUrl: `${process.env.REACT_APP_CHECKMATE_DOC360_URL}/docs/setting-up-the-bullhorn-integration`,
  },
  {
    name: 'cornerstone',
    partnerCode: PartnersCodes.Cornerstone,
    logo: partnerLogo('cornerstone.svg'),
    title: 'Cornerstone',
    description: 'Learn more about our Cornerstone integration',
    documentationUrl: `${process.env.REACT_APP_CHECKMATE_DOC360_URL}/docs/setting-up-the-cornerstone-integration`,
  },
  {
    name: 'expr3ss',
    logo: partnerLogo('expr3ss.svg'),
    title: 'Expr3ss!',
    description: 'Learn more about our Expr3ss! integration',
    infoOnly: true,
    documentationUrl: `${process.env.REACT_APP_CHECKMATE_DOC360_URL}/docs/setting-up-the-expr3ss-integration`,
  },
  {
    name: 'livehire',
    logo: partnerLogo('humanforce.svg'),
    title: 'Humanforce',
    description: 'Learn more about our Humanforce integration',
    documentationUrl: `${process.env.REACT_APP_CHECKMATE_DOC360_URL}/docs/setting-up-the-humanforce-integration`,
  },
  {
    name: 'imis',
    logo: partnerLogo('imis.svg'),
    title: 'iMIS',
    description: 'Learn more about our iMIS integration',
    infoOnly: true,
    documentationUrl: `${process.env.REACT_APP_CHECKMATE_DOC360_URL}/docs/setting-up-the-imis-integration`,
  },
  {
    name: 'jazzhr',
    logo: partnerLogo('jazzhr.svg'),
    title: 'JazzHR',
    description: 'Learn more about our JazzHR integration',
    documentationUrl: `${process.env.REACT_APP_CHECKMATE_DOC360_URL}/docs/setting-up-the-jazzhr-integration`,
  },
  {
    name: 'job_adder',
    logo: partnerLogo('jobadder.svg'),
    title: 'JobAdder',
    description: 'Learn more about our JobAdder integration',
    documentationUrl: `${process.env.REACT_APP_CHECKMATE_DOC360_URL}/docs/setting-up-the-jobadder-integration`,
  },
  {
    name: 'greenhouse',
    logo: partnerLogo('greenhouse.svg'),
    title: 'Greenhouse',
    description: 'Learn more about our Greenhouse integration',
    documentationUrl: `${process.env.REACT_APP_CHECKMATE_DOC360_URL}/docs/setting-up-the-greenhouse-integration`,
  },
  {
    name: 'jobylon',
    logo: partnerLogo('jobylon.svg'),
    title: 'Jobylon',
    description: 'Learn more about our Jobylon integration',
    documentationUrl: `${process.env.REACT_APP_CHECKMATE_DOC360_URL}/docs/setting-up-the-jobylon-integration`,
  },
  {
    name: 'lever',
    logo: partnerLogo('lever.svg'),
    title: 'Lever',
    description: 'Learn more about our Lever integration',
    documentationUrl: `${process.env.REACT_APP_CHECKMATE_DOC360_URL}/docs/setting-up-the-lever-integration`,
  },
  {
    name: 'pageup',
    logo: partnerLogo('pageup.svg'),
    title: 'PageUp',
    description: 'Learn more about our PageUp integration',
    documentationUrl: `${process.env.REACT_APP_CHECKMATE_DOC360_URL}/docs/setting-up-the-pageup-integration`,
  },
  {
    name: 'smartrecruiters',
    logo: partnerLogo('smartrecruiters.svg'),
    title: 'SmartRecruiters',
    description: 'Learn more about our SmartRecruiters integration',
    documentationUrl: `${process.env.REACT_APP_CHECKMATE_DOC360_URL}/docs/setting-up-the-smartrecruiters-integration`,
  },
  {
    name: 'ready_employ',
    logo: partnerLogo('ready_employ.svg'),
    title: 'Ready Employ',
    description: 'Learn more about our Ready Employ integration',
    documentationUrl: `${process.env.REACT_APP_CHECKMATE_DOC360_URL}/docs/setting-up-the-ready-employ-integration`,
  },
  {
    name: 'sap_successfactors',
    logo: partnerLogo('sap_successfactors.svg'),
    title: 'SAP SuccessFactors',
    description: 'Learn more about our SAP SuccessFactors integration',
    documentationUrl: `${process.env.REACT_APP_CHECKMATE_DOC360_URL}/docs/setting-up-the-sap-successfactors-integration`,
  },
  {
    name: 'snaphire',
    partnerCode: PartnersCodes.TAS,
    logo: partnerLogo('snaphire.svg'),
    title: 'SnapHire',
    description: 'Learn more about our SnapHire integration',
    documentationUrl: `${process.env.REACT_APP_CHECKMATE_DOC360_URL}/docs/setting-up-the-snaphire-integration`,
  },
  {
    name: 'springboard',
    logo: partnerLogo('springboard.svg'),
    title: 'Springboard',
    description: 'Learn more about our Springboard integration',
    infoOnly: true,
    documentationUrl: `${process.env.REACT_APP_CHECKMATE_DOC360_URL}/docs/setting-up-the-springboard-integration`,
  },
  {
    name: 'teamtailor',
    logo: partnerLogo('teamtailor.svg'),
    title: 'Teamtailor',
    description: 'Learn more about our Teamtailor integration',
    documentationUrl: `${process.env.REACT_APP_CHECKMATE_DOC360_URL}/docs/setting-up-the-teamtailor-integration`,
  },
  {
    name: 'ukg',
    logo: partnerLogo('ukg.svg'),
    title: 'UKG Ready',
    description: 'Learn more about our UKG Ready integration',
    infoOnly: true,
    documentationUrl: `${process.env.REACT_APP_CHECKMATE_DOC360_URL}/docs/setting-up-the-ukg-integration`,
  },
  {
    name: 'workable',
    logo: partnerLogo('workable.svg'),
    title: 'Workable',
    description: 'Learn more about our Workable integration',
    infoOnly: true,
    documentationUrl: `${process.env.REACT_APP_CHECKMATE_DOC360_URL}/docs/setting-up-the-integration-7`,
  },
  {
    name: 'workato',
    logo: partnerLogo('workato.svg'),
    title: 'Workato',
    description: 'Learn more about our Workato integration',
    infoOnly: true,
    contactMessageTemplate: 'Need help setting up a Workato workflow? Contact us at {email}.',
  },
  {
    name: 'workday',
    logo: partnerLogo('workday.svg'),
    title: 'Workday',
    description: 'Learn more about our Workday integration',
    infoOnly: true,
    documentationUrl: `${process.env.REACT_APP_CHECKMATE_DOC360_URL}/docs/setting-up-the-workday-integration`,
  },
];
